export default __webpack_public_path__ + "static/FilsonSoftMedium-a8fbb1cd47c517e8e9dd600b9e6e30ea.ttf";